import { message } from 'antd';

// Singleton для управления сообщениями
class MessageManager {
  constructor() {
    this.messageApi = null;
    this.pendingRequests = new Map(); // Хранит информацию о запросах
  }

  setMessageApi(api) {
    this.messageApi = api;
  }

  // Показать loading сообщение для запроса
  showLoading(requestId, customMessage = 'Загрузка...') {
    if (!this.messageApi) {
      console.warn('MessageAPI not initialized');
      return null;
    }

    const hide = this.messageApi.loading({
      content: customMessage,
      duration: 0, // Не закрывать автоматически
      key: requestId,
    });

    this.pendingRequests.set(requestId, { hide });
    return hide;
  }

  // Показать success сообщение
  showSuccess(requestId, customMessage = 'Успешно выполнено') {
    if (!this.messageApi) {
      console.warn('MessageAPI not initialized');
      return;
    }

    // Закрываем loading
    const pending = this.pendingRequests.get(requestId);
    if (pending?.hide) {
      pending.hide();
    }

    this.messageApi.success({
      content: customMessage,
      duration: 2.5,
      key: requestId,
    });

    this.pendingRequests.delete(requestId);
  }

  // Показать error сообщение
  showError(requestId, customMessage = 'Произошла ошибка') {
    if (!this.messageApi) {
      console.warn('MessageAPI not initialized');
      return;
    }

    // Закрываем loading
    const pending = this.pendingRequests.get(requestId);
    if (pending?.hide) {
      pending.hide();
    }

    this.messageApi.error({
      content: customMessage,
      duration: 3,
      key: requestId,
    });

    this.pendingRequests.delete(requestId);
  }

  // Показать warning сообщение
  showWarning(requestId, customMessage = 'Внимание') {
    if (!this.messageApi) {
      console.warn('MessageAPI not initialized');
      return;
    }

    // Закрываем loading
    const pending = this.pendingRequests.get(requestId);
    if (pending?.hide) {
      pending.hide();
    }

    this.messageApi.warning({
      content: customMessage,
      duration: 3,
      key: requestId,
    });

    this.pendingRequests.delete(requestId);
  }
}

export const messageManager = new MessageManager();

